import {useEffect} from "react";
import {parseExistingFiles} from "components/Shared/MDropzone/utility";

const useExistingFiles = ({overwriteFilesNoCallback, existingFiles = []}) => {
  useEffect(
    () => {
      overwriteFilesNoCallback(parseExistingFiles(existingFiles));
    },
    [existingFiles]
  );
};

export default useExistingFiles;